export interface Contact {
	id: string;
	firstName: string;
	lastName: string;
	email: string;
	phone: string;
	companyId: string | null;
	title: string;
	createdAt: string;
	updatedAt: string;
}

export interface Company {
	id: string;
	name: string;
	industry: string;
	website: string;
	phone: string;
	address: string;
	createdAt: string;
	updatedAt: string;
}

export type DealStage = "lead" | "qualified" | "proposal" | "negotiation" | "closed_won" | "closed_lost";

export interface Deal {
	id: string;
	title: string;
	value: number;
	stage: DealStage;
	companyId: string | null;
	contactId: string | null;
	description: string;
	expectedCloseDate: string;
	createdAt: string;
	updatedAt: string;
}

export type ActivityType = "call" | "email" | "meeting" | "note" | "task";

export interface Activity {
	id: string;
	type: ActivityType;
	subject: string;
	description: string;
	contactId: string | null;
	dealId: string | null;
	companyId: string | null;
	completed: boolean;
	dueDate: string | null;
	createdAt: string;
	updatedAt: string;
}

export interface Stats {
	totalDeals: number;
	totalContacts: number;
	totalCompanies: number;
	pipelineValue: number;
	wonValue: number;
	openActivities: number;
	dealsByStage: Record<DealStage, number>;
}

export const DEAL_STAGES: { value: DealStage; label: string }[] = [
	{ value: "lead", label: "Lead" },
	{ value: "qualified", label: "Qualified" },
	{ value: "proposal", label: "Proposal" },
	{ value: "negotiation", label: "Negotiation" },
	{ value: "closed_won", label: "Closed Won" },
	{ value: "closed_lost", label: "Closed Lost" },
];

export const ACTIVITY_TYPES: { value: ActivityType; label: string }[] = [
	{ value: "call", label: "Call" },
	{ value: "email", label: "Email" },
	{ value: "meeting", label: "Meeting" },
	{ value: "note", label: "Note" },
	{ value: "task", label: "Task" },
];
